import { AbstractControl, ValidatorFn } from '@angular/forms';

/* eslint-disable */
export const productGroupsSegmentData: any = [
  {
    'field_map': 'name',
    'item_name': 'name',
    'title': 'Group Name',
    'hint_detail': 'Group Name',
    'hint_panel' : 'Group Name',
    'example': '',
    'sequence': 1,
    'show_more': true,
    'lookup': null,
    'validation': {
      'PIES_6_5': {
        required: true,
        minLength: 1,
        maxLength: 50,
        message: 'Group Name is limited to 50 characters'
      }
    }
  },
  {
    'item_name': 'sub_groups',
    'field_map': 'subGroups',
    'title': 'Sub Groups',
    'hint_detail': 'Sub Groups',
    'hint_panel' : 'Sub Groups',
    'example': '',
    'sequence': 2,
    'show_more': true,
    'lookup': null
  },
  {
    'item_name': 'code',
    'field_map': 'code',
    'title': 'Code',
    'hint_detail': 'Code',
    'hint_panel' : 'Code',
    'example': 'PROGRP0001',
    'sequence': 3,
    'show_more': true,
    "validation": {
      'PIES_6_5': {
        maxLength: 10,
        required: true,
        custom: function (): ValidatorFn {
          return (control: AbstractControl): {[key: string]: any} => {
            if (control.value && !control.value.match(/^[a-z0-9]+$/i)) {
              return {'code': 'Cannot contain special characters'};
            }
            return null;
          };
        },
        message: 'Code must be provided and is limited to 10 characters'
      },
    },
    'lookup': null
  },
  {
    'item_name': 'description',
    'field_map': 'description',
    'title': 'Description',
    'hint_detail': 'Description',
    'hint_panel' : 'Description',
    'example': '',
    'sequence': 4,
    'show_more': true,
    'lookup': null,
    'validation': {
      'DESCRIPTION': {
        maxLength: 500,
        message: 'Description is limited to 500 characters'
      },
    },
  },
  {
    'item_name': 'item_count',
    'field_map': 'item_count',
    'title': 'Items',
    'hint_detail': 'Items',
    'hint_panel' : 'Items',
    'example': '',
    'sequence': 5,
    'show_more': true,
    'lookup': null
  },
  {
    'field_map': 'name',
    'item_name': 'sub_group_name',
    'title': 'Sub Group name',
    'hint_detail': 'Sub Group name',
    'hint_panel' : 'Sub Group name',
    'example': '',
    'sequence': 6,
    'show_more': true,
    'lookup': null,
    'validation': {
      'PIES_6_5': {
        required: true,
        minLength: 1,
        maxLength: 50,
        message: 'Sub Group name must be provided and is limited to 50 characters'
      }
    }
  },
  {
    'field_map': 'code',
    'item_name': 'sub_group_code',
    'title': 'Code',
    'hint_detail': 'Sub Group code',
    'hint_panel' : 'Sub Group code',
    'example': 'PROGRP0001',
    'sequence': 7,
    'show_more': true,
    "validation": {
      'PIES_6_5': {
        maxLength: 10,
        required: true,
        custom: function (): ValidatorFn {
          return (control: AbstractControl): {[key: string]: any} => {
            if (control.value && !control.value.match(/^[a-z0-9]+$/i)) {
              return {'code': 'Cannot contain special characters'};
            }
            return null;
          };
        },
        message: 'Sub Group code must be provided is limited to 10 characters'
      },
    },
    'lookup': null
  },
  {
    'field_map': 'item_count',
    'item_name': 'sub_group_item_count',
    'title': 'Items',
    'hint_detail': 'Sub Group items',
    'hint_panel' : 'Sub Group items',
    'example': '',
    'sequence': 8,
    'show_more': true,
    'lookup': null
  },
];
/* eslint-enable */
